import BigNumber from 'bignumber.js';

import {
  getExtendedErrorText,
  mainApi,
  queryFnNotifyWrapper,
} from 'modules/api';
import { getConnectedIotaProvider } from 'modules/auth';
import { authCacheTags } from 'modules/auth/authCacheTags';
import { currentEnv } from 'modules/common';
import { stakeCacheTags } from 'modules/stake/stakeCacheTags';

import { getStakeGasEstimation } from '../api/getStakeGasEstimation';

interface IParams {
  amount: BigNumber.Value;
}

interface IResult {
  estimatedGas: BigNumber;
}

export const { useLazyGetStakeGasEstimationQuery } = mainApi.injectEndpoints({
  endpoints: build => ({
    getStakeGasEstimation: build.query<IResult, IParams>({
      queryFn: queryFnNotifyWrapper<IParams, never, IResult>(
        async ({ amount }) => {
          const provider = getConnectedIotaProvider();

          return {
            data: await getStakeGasEstimation({
              walletAccount: provider.getWalletAccount(),
              client: provider.getClient(),
              amount: new BigNumber(amount),
              env: currentEnv,
            }),
          };
        },
        error => getExtendedErrorText(error, 'Failed to estimate gas'),
      ),
      providesTags: [stakeCacheTags.getStakeGasEstimation],
    }),
  }),
});
